import { useEffect, useState } from 'react';

/**
 * Devolve o valor só depois que ele parou de mudar por `delay` ms.
 * Usado nos filtros de texto para consultar o backend quando o usuário termina de digitar,
 * e não a cada tecla.
 */
function useDebouncedValue(value, delay = 400) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const timer = setTimeout(() => setDebouncedValue(value), delay);
        return () => clearTimeout(timer);
    }, [value, delay]);

    return debouncedValue;
}

export default useDebouncedValue;
